import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import {Container} from '../ui';
import Chat from './chat/main';
import { connect } from 'react-redux';
import { updateLWCFeed } from 'actions';
import { sockets } from 'utils';

class LiveWeatherCenter extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'LiveWeatherCenter';
        this.updateSizing = this.updateSizing.bind(this);

        this.socket = null;
    }

    componentWillMount() {
      this.socket = sockets();

      // Request current video feed.
      this.socket.emit('chat-feed-update');

      // Set current video feed.
      this.socket.on('chat-feed-updated', (feed_url) => {
        console.log('feed_url retrieved: ' + feed_url);
        if (typeof feed_url !== 'undefined') {
          this.props.dispatch(updateLWCFeed(feed_url));
        }
      });
    }

    componentDidMount() {
      $(window).resize(this.updateSizing);
      this.updateSizing();
    }

    componentDidUpdate(prevProps, prevState) {
      this.updateSizing();
    }

    updateSizing() {
        var videoWrapper = $(ReactDom.findDOMNode(this.refs.videoWrapper));
        var height = $(window).height() - videoWrapper.offset().top;
        videoWrapper.height(height-3);
    }

    render() {
      const feed_url = this.props.liveWeatherCenter.feed_url;

      return (
      	<Container title="Live Weather Center">
          <div className="row live-weather-center" style={{top: 0, right: 0, bottom: 0, left : 0, position: "relative"}}>
            <div ref='videoWrapper' className="col-xs-12 col-md-8 col-lg-8">
              <iframe style={{
                  width:"100%",
                  height:"100%",
                  top:"0px",
                  left:"0px",
                  right:"0px",
                  bottom:"0px",
                  position:"absolute",
                  frameborder : "none"
                }} src={feed_url} frameBorder="0" allowFullScreen></iframe>

            </div>
            <div ref="chat-col" className="col-xs-12 col-md-4 col-lg-4 lwc-chat-container">
              <Chat/>
            </div>
          </div>
        </Container>
      );
    }
}

function mapStateToProps({liveWeatherCenter}) {
	return {
		liveWeatherCenter
	}
}

export default connect(mapStateToProps)(LiveWeatherCenter);



// WEBPACK FOOTER //
// ./src/browser/components/live_weather_center/live_weather_center.js